import WaCatalogService from '../../services/WaCatalogService'

// Catálogo de produtos do WhatsApp — a Meta é a fonte da verdade (sem cache local)
const state = () => ({
    waCatalogId: null,
    waProducts: [],
    /** Cursor da próxima página na Meta (null = fim) */
    waProductsAfter: null,
    loadingWaCatalog: false,
    savingWaProduct: false,
})

const mutations = {
    SET_WA_CATALOG: (state, { catalogId, itens, after, append = false }) => {
        state.waCatalogId = catalogId
        state.waProducts = append ? [...state.waProducts, ...itens] : itens
        state.waProductsAfter = after
    },
    SET_LOADING_WA_CATALOG: (state, payload) => {
        state.loadingWaCatalog = payload
    },
    SET_SAVING_WA_PRODUCT: (state, payload) => {
        state.savingWaProduct = payload
    },
}

const actions = {
    async fetchWaCatalog({ commit }, { after = null } = {}) {
        try {
            commit('SET_LOADING_WA_CATALOG', true)
            const response = await WaCatalogService.listProducts(after)
            commit('SET_WA_CATALOG', { ...response.data, append: !!after })
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.error || error.response?.data?.message || 'Falha ao carregar o catálogo.'
            })
        } finally {
            commit('SET_LOADING_WA_CATALOG', false)
        }
    },

    async createWaProduct({ commit, dispatch }, data) {
        try {
            commit('SET_SAVING_WA_PRODUCT', true)
            await WaCatalogService.createProduct(data)
            commit('SET_ALERT', { heading: 'success', message: 'Produto criado no catálogo!' })
            await dispatch('fetchWaCatalog')
            return true
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.error || error.response?.data?.message || 'Falha ao criar o produto.'
            })
            return false
        } finally {
            commit('SET_SAVING_WA_PRODUCT', false)
        }
    },

    async updateWaProduct({ commit, dispatch }, { id, ...data }) {
        try {
            commit('SET_SAVING_WA_PRODUCT', true)
            await WaCatalogService.updateProduct(id, data)
            commit('SET_ALERT', { heading: 'success', message: 'Produto atualizado!' })
            await dispatch('fetchWaCatalog')
            return true
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.error || error.response?.data?.message || 'Falha ao atualizar o produto.'
            })
            return false
        } finally {
            commit('SET_SAVING_WA_PRODUCT', false)
        }
    },

    async deleteWaProduct({ commit, dispatch }, id) {
        try {
            commit('SET_SAVING_WA_PRODUCT', true)
            await WaCatalogService.deleteProduct(id)
            commit('SET_ALERT', { heading: 'success', message: 'Produto excluído do catálogo.' })
            await dispatch('fetchWaCatalog')
            return true
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.error || error.response?.data?.message || 'Falha ao excluir o produto.'
            })
            return false
        } finally {
            commit('SET_SAVING_WA_PRODUCT', false)
        }
    },

    async saveWaCatalogConfig({ commit, dispatch }, catalogId) {
        try {
            commit('SET_SAVING_WA_PRODUCT', true)
            await WaCatalogService.saveConfig(catalogId)
            commit('SET_ALERT', { heading: 'success', message: 'Catálogo configurado.' })
            await dispatch('fetchWaCatalog')
            return true
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao salvar a configuração.'
            })
            return false
        } finally {
            commit('SET_SAVING_WA_PRODUCT', false)
        }
    },
}

const getters = {
    getWaCatalogId: state => state.waCatalogId,
    getWaProducts: state => state.waProducts,
    getWaProductsAfter: state => state.waProductsAfter,
    getLoadingWaCatalog: state => state.loadingWaCatalog,
    getSavingWaProduct: state => state.savingWaProduct,
}

export default {
    state,
    getters,
    mutations,
    actions
};
